import classNames from 'classnames';
import { Text, textVariantsEnum, fontWeightEnum } from '../Text';
import NoDataPlaceholder from '@assets/img/svg/no-data-placeholder.svg';
import styles from './EmptyState.module.scss';

/**
 * `illustration` opts into the full page-level empty state (illustration +
 * bold title + description) — use this for whole pages/tables, not the
 * small in-card placeholder (e.g. a dashboard widget with no data yet),
 * which should keep using the plain `message` form below.
 */
export const EmptyStateComponent = ({
  message,
  customMessageComponent,
  illustration = false,
  title,
  description,
  action,
  className,
}) => {
  if (illustration) {
    return (
      <div className={classNames(styles.pageEmptyState, className)}>
        <img
          src={NoDataPlaceholder}
          alt=""
          className={styles.pageEmptyStateImage}
        />
        <Text
          variant={textVariantsEnum.Text_xl}
          fontWeight={fontWeightEnum.Bold}
          className={styles.pageEmptyStateTitle}
        >
          {title || 'No Data Found'}
        </Text>
        {description && (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            className={styles.pageEmptyStateDescription}
          >
            {description}
          </Text>
        )}
        {action && <div className={styles.pageEmptyStateAction}>{action}</div>}
      </div>
    );
  }

  return (
    <div className={classNames(styles.emptyStateContainer, className)}>
      {customMessageComponent ? (
        customMessageComponent
      ) : (
        <Text
          variant={textVariantsEnum.Text_md}
          fontWeight={fontWeightEnum.Medium}
        >
          {message ? message : 'No Data Found'}
        </Text>
      )}
    </div>
  );
};
